var map = {
	"./nav-links.config.1.en-US.json": "459E",
	"./nav-links.config.1.es-US.json": "9huF",
	"./nav-links.config.1.fr-CA.json": "pchY",
	"./nav-links.config.10.it-IT.json": "pYYp",
	"./nav-links.config.11.nl-NL.json": "WPW9",
	"./nav-links.config.12.de-AT.json": "+bdl",
	"./nav-links.config.13.fr-BE.json": "rbIA",
	"./nav-links.config.13.nl-BE.json": "lGih",
	"./nav-links.config.14.en-IE.json": "40fr",
	"./nav-links.config.15.fi-FI.json": "DwW/",
	"./nav-links.config.16.de-LU.json": "mUF0",
	"./nav-links.config.16.fr-LU.json": "O9gw",
	"./nav-links.config.17.el-GR.json": "0JXt",
	"./nav-links.config.18.pl-PL.json": "MhZm",
	"./nav-links.config.19.sv-SE.json": "PZ/+",
	"./nav-links.config.2.en-GB.json": "wdBW",
	"./nav-links.config.20.da-DK.json": "avUG",
	"./nav-links.config.21.es-AR.json": "l2Zt",
	"./nav-links.config.22.ja-JP.json": "s6CQ",
	"./nav-links.config.23.ko-KR.json": "kj2O",
	"./nav-links.config.24.pt-BR.json": "/bXm",
	"./nav-links.config.26.tr-TR.json": "eOFu",
	"./nav-links.config.27.zh-TW.json": "xto5",
	"./nav-links.config.28.en-HK.json": "qNpW",
	"./nav-links.config.28.zh-CN.json": "4eMh",
	"./nav-links.config.28.zh-HK.json": "SIgU",
	"./nav-links.config.3.de-DE.json": "WiTp",
	"./nav-links.config.4.fr-FR.json": "3oKw",
	"./nav-links.config.5.es-MX.json": "ag7z",
	"./nav-links.config.6.es-ES.json": "nNjF",
	"./nav-links.config.7.pt-PT.json": "duFF",
	"./nav-links.config.7.pt.json": "T63c",
	"./nav-links.config.8.en-CA.json": "5nut",
	"./nav-links.config.8.fr-CA.json": "oTr9",
	"./nav-links.config.9.cs-CZ.json": "eFT0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YTDv";